import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const submitSpeaking = (data) => client.post("/inquiries/speaking", data).then((r) => r.data);
export const submitWorkshop = (data) => client.post("/inquiries/workshop", data).then((r) => r.data);
export const submitCoaching = (data) => client.post("/inquiries/coaching", data).then((r) => r.data);
export const submitContact  = (data) => client.post("/inquiries/contact",  data).then((r) => r.data);
